export var IdCoopSettings;
(function (IdCoopSettings) {
    IdCoopSettings[IdCoopSettings["Standard"] = 1] = "Standard";
})(IdCoopSettings || (IdCoopSettings = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdCoopSettings.ts
// module id = 1141
// module chunks = 3